<template>
  <section class="modal login-modal">
    <div class="box login-card">
      <button type="button" class="login-close" @click="closeModal" aria-label="Fechar">
        <i class="fas fa-times"></i>
      </button>

      <div class="login-brand">
        <img class="login-logo" src="/img/swiss.png" alt="Swiss Money" title="Swiss Money">
        <transition name="title">
          <p v-if="page === 1" key="enter" class="login-subtitle">Acesse sua conta Swiss Money</p>
          <p v-if="page === 2" key="register" class="login-subtitle">Crie sua conta gratuitamente</p>
          <p v-if="page === 3 && newPassword" key="change-pass" class="login-subtitle">Complete seu cadastro</p>
          <p v-if="page === 4" key="confirm-email" class="login-subtitle">Confira seu e-mail</p>
          <p v-if="page === 5" key="login-change-pass" class="login-subtitle">Alterar senha</p>
        </transition>
      </div>

      <div v-if="page === 1 || page === 2" class="login-tabs">
        <button type="button" :class="{ active: page === 1 }" @click="page = 1">Entrar</button>
        <button type="button" :class="{ active: page === 2 }" @click="page = 2">Cadastrar</button>
      </div>

      <transition name="page">
        <!-- Entrar -->
        <div v-if="page === 1" key="page-1">
          <form @submit.prevent="signIn" class="form login-form">
            <div v-show="false">
              <button @click="facebookSign" type="button" class="button-facebook">
                <i :class="loadingFacebook ? 'fas fa-spinner loading' : 'fab fa-facebook-f'"></i><span>Entrar com o Facebook</span>
              </button>
              <div v-if="error.includes('facebook')" class="hint hint-center">Não foi possível entrar com o Facebook! Por favor tente novamente.</div>
              <button v-if="!android" @click="appleSign" type="button" class="button-apple">
                <i :class="loadingApple ? 'fas fa-spinner loading' : 'fab fa-apple'"></i><span>Sign in with Apple</span>
              </button>
              <div v-if="error.includes('apple')" class="hint hint-center">Não foi possível entrar com a Apple! Por favor tente novamente.</div>
              <div class="divider" data-text="OU"></div>
            </div>

            <div class="field-group">
              <label for="login">E-mail</label>
              <div class="field-input" :class="{ 'has-error': error.includes('login') || error.includes('invalid') }">
                <i class="fas fa-envelope field-icon"></i>
                <input
                  v-model="login"
                  type="email"
                  ref="login"
                  id="login"
                  placeholder="seu@email.com"
                  :class="{ error: error.includes('login') || error.includes('invalid') }"
                  style="text-transform: lowercase;"
                  autocomplete="email"
                />
              </div>
              <div v-if="error.includes('login')" class="hint">Você esqueceu o e-mail</div>
            </div>

            <div class="field-group">
              <label for="password">Senha</label>
              <div class="field-input" :class="{ 'has-error': error.includes('password') || error.includes('invalid') }">
                <i class="fas fa-lock field-icon"></i>
                <input
                  v-model="password"
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  placeholder="Sua senha"
                  :class="{ error: error.includes('password') || error.includes('invalid') }"
                  autocomplete="current-password"
                />
                <button type="button" class="field-toggle" @click="showPassword = !showPassword" tabindex="-1">
                  <i class="fas" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              <div v-if="error.includes('password')" class="hint">Senha inválida</div>
              <div v-if="error.includes('invalid')" class="hint">E-mail ou senha inválidos</div>
              <div v-if="error.includes('notValidated')" class="hint hint-center">Conta não ativada. Foi enviado um email em {{ login }} para você ativar sua conta.</div>
            </div>

            <div class="login-actions-row">
              <button type="button" @click="forgotPass" class="link-btn">Esqueci minha senha</button>
            </div>

            <button type="submit" class="btn-primary" :disabled="loading">
              <i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-arrow-right'"></i>
              <span>Entrar</span>
            </button>

            <div v-if="error.includes('blocked')" class="alert alert-error">Bloqueado pelas tentativas! Tente novamente mais tarde.</div>
            <div v-if="error.includes('internal')" class="alert alert-error">Alguma coisa deu errado! Tente novamente.</div>
          </form>
        </div>

        <!-- Cadastrar -->
        <div v-if="page === 2" key="page-2">
          <form @submit.prevent="signOn" class="form login-form login-form--register">
            <div class="field-group">
              <label>Nome completo</label>
              <div class="field-input" :class="{ 'has-error': error.includes('name') }">
                <i class="fas fa-user field-icon"></i>
                <input v-model="name" type="text" style="text-transform: uppercase;" placeholder="Nome e sobrenome" :class="{ error: error.includes('name') }" autocomplete="name"/>
              </div>
              <div v-if="error.includes('name')" class="hint">Nome inválido! Precisa ser nome e sobrenome.</div>
            </div>

            <div class="field-group">
              <label>E-mail</label>
              <div class="field-input" :class="{ 'has-error': error.includes('login') || error.includes('exists') }">
                <i class="fas fa-envelope field-icon"></i>
                <input v-model="login" type="email" placeholder="seu@email.com" :class="{ error: error.includes('login') || error.includes('exists') }" style="text-transform: lowercase;" autocomplete="email"/>
              </div>
              <div v-if="error.includes('login')" class="hint">Você esqueceu o e-mail</div>
              <div v-if="error.includes('exists')" class="hint">Já existe um usuário cadastrado com esse e-mail</div>
            </div>

            <div class="field-group">
              <label>Celular</label>
              <div class="field-input" :class="{ 'has-error': error.includes('phone') }">
                <i class="fas fa-phone field-icon"></i>
                <input v-model="phone" type="text" placeholder="(00) 00000-0000" :class="{ error: error.includes('phone') }" autocomplete="tel"/>
              </div>
              <div v-if="error.includes('phone')" class="hint">Número de celular inválido</div>
            </div>

            <div v-if="!gringo" class="field-group">
              <label>CPF</label>
              <div class="field-input" :class="{ 'has-error': error.includes('cpf') }">
                <i class="fas fa-id-card field-icon"></i>
                <input v-model="cpf" v-mask="['###.###.###-##']" type="text" placeholder="000.000.000-00" :class="{ error: error.includes('cpf') }"/>
              </div>
              <div v-if="error.includes('cpf')" class="hint">Número de CPF inválido</div>
            </div>

            <template v-if="provider === 'local'">
              <div class="field-group">
                <label>Senha</label>
                <div class="field-input" :class="{ 'has-error': error.includes('password') }">
                  <i class="fas fa-lock field-icon"></i>
                  <input v-model="password" :type="showPassword ? 'text' : 'password'" placeholder="Crie uma senha" :class="{ error: error.includes('password') }" autocomplete="new-password"/>
                  <button type="button" class="field-toggle" @click="showPassword = !showPassword" tabindex="-1">
                    <i class="fas" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
                <div v-if="error.includes('password')" class="hint">Você esqueceu a senha</div>
              </div>

              <div class="field-group">
                <label>Repita a senha</label>
                <div class="field-input" :class="{ 'has-error': error.includes('password2') }">
                  <i class="fas fa-lock field-icon"></i>
                  <input v-model="password2" :type="showPassword2 ? 'text' : 'password'" placeholder="Confirme sua senha" :class="{ error: error.includes('password2') }" autocomplete="new-password"/>
                  <button type="button" class="field-toggle" @click="showPassword2 = !showPassword2" tabindex="-1">
                    <i class="fas" :class="showPassword2 ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </button>
                </div>
                <div v-if="error.includes('password2')" class="hint">Repita a senha corretamente</div>
              </div>
            </template>

            <div class="field-group">
              <label>Como conheceu o Swiss Money?</label>
              <div class="field-input field-input--select">
                <i class="fas fa-bullhorn field-icon"></i>
                <select v-model="fonte">
                  <option value="NENHUM">Nenhum</option>
                  <option value="TERCIO">Trader de Mesa Proprietária</option>
                  <option value="REGIS">Pra cima Traders</option>
                  <option value="ANDERSON">Mesa Prop Americana/Trader Funding (Anderson)</option>
                  <option value="SWISS">Swiss Money Global</option>
                  <option value="OUTRO">Outro</option>
                </select>
              </div>
            </div>

            <div v-if="fonte === 'OUTRO'" class="field-group">
              <label>Por favor, digite aqui</label>
              <div class="field-input">
                <i class="fas fa-pen field-icon"></i>
                <input v-model="newfonte" type="text" placeholder="De onde veio?" style="text-transform: uppercase;"/>
              </div>
            </div>

            <button type="submit" class="btn-primary" :disabled="loading">
              <i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-check'"></i>
              <span>Finalizar cadastro</span>
            </button>

            <div v-if="error.includes('blocked')" class="alert alert-error">Bloqueado pelas tentativas! Tente novamente mais tarde.</div>
            <div v-if="error.includes('internal')" class="alert alert-error">Alguma coisa deu errado! Tente novamente.</div>
          </form>
        </div>

        <!-- Alterar Senha -->
        <div v-if="page === 3 || page === 5" key="page-3">
          <div class="change-pass-info">
            <i class="fas fa-envelope-open-text"></i>
            <p>Enviamos um código de verificação para <strong>{{ login }}</strong></p>
          </div>
          <form @submit.prevent class="form login-form">
            <div class="field-group">
              <label>Código de verificação</label>
              <div class="field-input" :class="{ 'has-error': error.includes('code') }">
                <i class="fas fa-key field-icon"></i>
                <input v-model="code" v-mask="'########'" type="text" placeholder="Código enviado por e-mail" :class="{ error: error.includes('code') }"/>
              </div>
              <div v-if="error.includes('code')" class="hint">Código inválido</div>
              <button type="button" @click="forgotPass" class="link-btn">Reenviar código</button>
            </div>

            <template v-if="page === 3">
              <div class="field-group">
                <label>Nome completo</label>
                <div class="field-input" :class="{ 'has-error': error.includes('name') }">
                  <i class="fas fa-user field-icon"></i>
                  <input v-model="name" type="text" style="text-transform: uppercase;" placeholder="Nome e sobrenome" :class="{ error: error.includes('name') }"/>
                </div>
                <div v-if="error.includes('name')" class="hint">Nome inválido! Precisa ser nome e sobrenome.</div>
              </div>

              <div class="field-group">
                <label>Celular</label>
                <div class="field-input" :class="{ 'has-error': error.includes('phone') }">
                  <i class="fas fa-phone field-icon"></i>
                  <input v-model="phone" type="text" placeholder="(00) 00000-0000" :class="{ error: error.includes('phone') }"/>
                </div>
                <div v-if="error.includes('phone')" class="hint">Número de celular inválido</div>
              </div>
            </template>

            <div class="field-group">
              <label>Nova senha</label>
              <div class="field-input" :class="{ 'has-error': error.includes('password') }">
                <i class="fas fa-lock field-icon"></i>
                <input v-model="password" :type="showPassword ? 'text' : 'password'" placeholder="Nova senha" :class="{ error: error.includes('password') }"/>
                <button type="button" class="field-toggle" @click="showPassword = !showPassword" tabindex="-1">
                  <i class="fas" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              <div v-if="error.includes('password')" class="hint">Senha inválida</div>
            </div>

            <div class="field-group">
              <label>Repita a senha</label>
              <div class="field-input" :class="{ 'has-error': error.includes('password2') }">
                <i class="fas fa-lock field-icon"></i>
                <input v-model="password2" :type="showPassword2 ? 'text' : 'password'" placeholder="Confirme a senha" :class="{ error: error.includes('password2') }"/>
                <button type="button" class="field-toggle" @click="showPassword2 = !showPassword2" tabindex="-1">
                  <i class="fas" :class="showPassword2 ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
              </div>
              <div v-if="error.includes('password2')" class="hint">Repita a senha corretamente</div>
            </div>

            <button type="button" @click="changePass" class="btn-primary" :disabled="loading">
              <i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-check'"></i>
              <span>{{ page === 3 ? 'Finalizar' : 'Atualizar senha' }}</span>
            </button>

            <div v-if="error.includes('blocked')" class="alert alert-error">Bloqueado pelas tentativas! Tente novamente mais tarde.</div>
            <div v-if="error.includes('internal')" class="alert alert-error">Alguma coisa deu errado! Tente novamente.</div>
          </form>
        </div>

        <div v-if="page === 4" key="page-4">
          <form @submit.prevent class="form login-form login-form--centered">
            <div class="confirm-email-icon">
              <i class="fas fa-envelope-circle-check"></i>
            </div>
            <p class="confirm-email-text">Verifique sua caixa de entrada para confirmar o cadastro.</p>
            <button type="button" @click="closeModal" class="btn-primary">
              <span>Fechar</span>
            </button>
          </form>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { setToken, loadModule } from '../../util'
import {
  signin,
  signon,
  facebookSignin,
  facebookSignon,
  facebook,
  forgotPass,
  forgotPassChange,
  // savePlayerId,
  apple,
  appleSignin,
  appleSignon
} from '../api/auth'
// import { get as getCustomer } from '../api/customer'

export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      loadingFacebook: false,
      page: 1,
      error: [],
      login: '',
      password: '',
      password2: null,
      name: null,
      phone: null,
      cpf: null,
      gringo: false,
      provider: 'local',
      providerToken: null,
      providerId: null,
      code: null,
      newPassword: false,
      loadingApple: false,
      android: process.env.CORDOVA_PLATFORM === 'android',
      fonte: null,
      newfonte: null,
      showPassword: false,
      showPassword2: false
    }
  },
  watch: {
    page (newValue, oldValue) {
      this.error = ['']
      if (this.provider === 'local' && newValue !== 3 && newValue !== 5) {
        this.login = null
        this.name = null
        this.phone = null
        this.cpf = null
        this.gringo = false
        this.password = null
        this.password2 = null
        this.fonte = null
        this.newfonte = null
      }
    }
  },
  async mounted () {
    try {
      // New user
      if (this.$route.query.new) {
        this.page = 3
        this.login = this.$route.query.new
        this.newPassword = true
        await forgotPass(this.login, true)
      } else {
        setTimeout(() => this.$refs.login.focus(), 1000)
      }
    } catch (error) {
      const data = error.response ? error.response.data : {}
      // Validation error
      if (data.error === 'Validation error') {
        this.error = data.fields
      // Invalid login or password
      } else if (data.error === 'user_not_found') {
        this.error = ['invalid']
      } else if (data.error === 'user_not_validated') {
        this.error = ['notValidated']
      } else if (data.error === 'user_not_completed') {
        this.newPassword = true
        this.page = 3
        this.$message.success('Código de verificação enviado com sucesso', { duration: 3000 })
      } else if (data.error === 'user_created') {
        this.page = 1
        setTimeout(() => this.$refs.login.focus(), 1000)
        this.$router.push('/')
      } else if (data.error === 'Too many attemps') {
        this.error = ['blocked']
      } else {
        this.error = ['internal']
        logger.error(error, this)
      }
    }
  },
  methods: {
    closeModal () {
      this.$store.commit('showLogin', false)
    },
    async signIn () {
      if (this.loading) return false
      this.loading = true
      try {
        // Clean errors
        this.error = []
        // Sign in on frontend
        const data = await signin(this.login, this.password)
        // Set token on axios header
        setToken(data.token)
        if (data.user.role === 'admin') {
          // Start admin module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('admin', data.user)
          document.body.style.backgroundColor = '#f2f2f2'
        } else if (data.user.role === 'business' || data.user.role === 'producer') {
          // Start business module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('business', data.user, data.business)
        } else {
          // Start user module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('user', data.user)
          /*
          // Save user on store
          this.$store.commit('user', data.user)
          document.body.style.backgroundColor = '#f2f2f2'
          // One Signal
          // await this.oneSignal()
          this.$analytics.event('signin')
          if (this.$store.state.redirect) {
            this.$router.push(this.$store.state.redirect)
            this.$store.commit('redirect', null)
          }
          */
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // Invalid login or password
        } else if (data.error === 'Invalid login or password') {
          this.error = ['invalid']
        // Too many attemps
        } else if (data.error === 'Email account not validated yet') {
          this.error = ['notValidated']
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async signOn () {
      if (this.loading) return false
      this.loading = true
      try {
        // Clean errors
        this.error = []
        let data = null
        // Sign On
        if (this.provider === 'facebook') {
          data = await facebookSignon(this.providerToken, this.providerId, this.login, this.phone, this.name)
        } else if (this.provider === 'apple') {
          data = await appleSignon(this.providerToken, this.login, this.phone, this.name)
        } else {
          if (this.newfonte) {
            this.fonte = this.newfonte
          }
          data = await signon(this.login, this.name, this.phone, this.cpf, this.password, this.password2, this.fonte, this.gringo)

          // Set token on axios header
          setToken(data.token)
          if (data.user.role === 'admin') {
            // Start admin module
            this.$store.commit('showLogin', false)
            document.body.style.backgroundColor = '#f2f2f2'
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('admin', data.user)
          } else if (data.user.role === 'business' || data.user.role === 'producer') {
            // Start business module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('business', data.user, data.business)
          } else {
            // Save user on store
            document.body.style.backgroundColor = '#f2f2f2'
            loadModule('user', data.user)
            this.$store.commit('user', data.user)
            this.$router.push('/')
            this.$root.$destroy()
            // One Signal
            // await this.oneSignal()
            this.$analytics.event('signon')
            if (this.$store.state.redirect) {
              this.$router.push(this.$store.state.redirect)
              this.$store.commit('redirect', null)
            }
            this.$store.commit('showLogin', false)
          }
        }

        /* if (this.provider === 'facebook' || this.provider === 'apple') {
          // Set token on axios header
          setToken(data.token)
          this.$store.commit('user', data.user)
          // One Signal
          await this.oneSignal()
          this.$analytics.event('signon')
          if (this.$store.state.redirect) {
            this.$router.push(this.$store.state.redirect)
            this.$store.commit('redirect', null)
          }
          this.$store.commit('showLogin', false)
        } else {
          this.page = 4
        } */
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // User already exists
        } else if (data.error === 'User already exists') {
          this.error = ['exists']
        // Too many attemps
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async facebookSign () {
      if (this.loadingFacebook) return false
      this.loadingFacebook = true
      try {
        // Call Facebook API
        const { accessToken, id, email, name } = await facebook()
        const data = await facebookSignin(accessToken, id)
        // Sign in
        if (data.token && data.user) {
          setToken(data.token)
          if (data.user.role === 'admin') {
            // Start admin module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('admin', data.user)
            document.body.style.backgroundColor = '#f2f2f2'
          } else if (data.user.role === 'business' || data.user.role === 'producer') {
            // Start business module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('business', data.user, data.business)
          } else {
            // Save user on store
            this.$store.commit('user', data.user)
            // One Signal
            // await this.oneSignal()
            this.$analytics.event('signin', 'facebook')
            if (this.$store.state.redirect) {
              this.$router.push(this.$store.state.redirect)
              this.$store.commit('redirect', null)
            }
            this.$store.commit('showLogin', false)
            document.body.style.backgroundColor = '#f2f2f2'
          }
        // New user
        } else {
          this.provider = 'facebook'
          this.providerToken = accessToken
          this.providerId = id
          this.login = email
          this.name = name
          this.page = 2
        }
      } catch (error) {
        this.error = ['facebook']
        logger.error(error, this)
      }
      this.loadingFacebook = false
    },
    async forgotPass () {
      try {
        this.error = []
        await forgotPass(this.login)
        this.$message.success('Código de verificação enviado com sucesso', { duration: 3000 })
        if (this.$route.query.new) {
          this.page = 3
        } else {
          this.page = 5
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // Invalid login or password
        } else if (data.error === 'user_not_found') {
          this.error = ['invalid']
        } else if (data.error === 'user_not_validated') {
          this.error = ['notValidated']
        } else if (data.error === 'user_not_completed') {
          this.newPassword = true
          this.page = 3
          this.$message.success('Código de verificação enviado com sucesso', { duration: 3000 })
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
    },
    async changePass () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        const data = await forgotPassChange(this.login, this.code, this.password, this.password2, this.name, this.phone)
        // Set token on axios header
        setToken(data.token)
        if (data.user.role === 'admin') {
          // Start admin module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('admin', data.user)
        } else if (data.user.role === 'business' || data.user.role === 'producer') {
          // Start business module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('business', data.user, data.business)
        } else {
          // Save user on store
          this.$store.commit('user', data.user)
          // One Signal
          await this.oneSignal()
          this.$analytics.event('signin')
          if (this.$store.state.redirect) {
            this.$router.push(this.$store.state.redirect)
            this.$store.commit('redirect', null)
          }
          if (this.$route.query.new) {
            this.$router.push('/')
          }
          this.$store.commit('showLogin', false)
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // Too many attemps
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async oneSignal () {
      if (process.env.NODE_ENV !== 'production') return false
      /*
      // CORDOVA
      if (process.env.CORDOVA_PLATFORM) {
        window.plugins.OneSignal.getPermissionSubscriptionState(async (status) => {
          if (status.subscriptionStatus.subscribed) {
            await savePlayerId(status.subscriptionStatus.userId)
            const customer = await getCustomer()
            window.plugins.OneSignal.setExternalUserId(customer.userId)
            window.plugins.OneSignal.sendTags({
              user_id: customer.userId,
              user_type: 'user',
              real_name: customer.name,
              first_name: customer.name.split(' ')[0]
            })
            window.plugins.OneSignal.setEmail(customer.login)
          }
        })
      // WEB
      } else {
        const pushEnabled = window.OneSignal ? await window.OneSignal.isPushNotificationsEnabled() : null
        if (pushEnabled) {
          const playerId = await window.OneSignal.getUserId()
          await savePlayerId(playerId)
          const customer = await getCustomer()
          window.OneSignal.setExternalUserId(customer.userId)
          window.OneSignal.push(() => {
            window.OneSignal.sendTags({
              user_id: customer.userId,
              user_type: 'user',
              real_name: customer.name,
              first_name: customer.name.split(' ')[0]
            })
          })
          window.OneSignal.setEmail(customer.login)
        }
      }
      */
    },
    async appleSign () {
      if (this.loadingApple) return false
      this.loadingApple = true
      try {
        // Call Apple Sing In
        const appleCredential = await apple()
        const data = await appleSignin(appleCredential.token)
        // Sign in
        if (data.token && data.user) {
          setToken(data.token)
          if (data.user.role === 'admin') {
            // Start admin module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('admin', data.user)
          } else if (data.user.role === 'business' || data.user.role === 'producer') {
            // Start business module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('business', data.user, data.business)
          } else {
            // Save user on store
            this.$store.commit('user', data.user)
            // One Signal
            await this.oneSignal()
            this.$analytics.event('signin', 'apple')
            if (this.$store.state.redirect) {
              this.$router.push(this.$store.state.redirect)
              this.$store.commit('redirect', null)
            }
            this.$store.commit('showLogin', false)
          }
        // New user
        } else {
          this.provider = 'apple'
          this.providerToken = appleCredential.token
          this.login = data.email
          this.name = appleCredential.name
          this.page = 2
        }
      } catch (error) {
        this.error = ['apple']
        logger.error(error, this)
      }
      this.loadingApple = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.login-modal {
  background-color: rgba(10, 10, 15, 0.75);
  backdrop-filter: blur(8px);

  &.modal .box.login-card {
    background: linear-gradient(160deg, #141418 0%, #1a1a22 50%, #12121a 100%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(81, 52, 245, 0.1);
  }
}

.login-card {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 95%;
  overflow-y: auto;
  padding: 0 0 24px;
}

.login-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s, transform 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    transform: scale(1.05);
  }

  &:focus {
    outline: none;
  }
}

.login-brand {
  text-align: center;
  padding: 32px 24px 8px;
}

.login-logo {
  height: 36px;
  margin-bottom: 12px;
}

.login-subtitle {
  margin: 0;
  font-size: 0.95em;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.4;
}

.login-tabs {
  display: flex;
  margin: 16px 24px 0;
  padding: 4px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  gap: 4px;

  button {
    flex: 1;
    padding: 10px 16px;
    border: none;
    border-radius: 9px;
    background: transparent;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.9em;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;

    &.active {
      background: rgba(81, 52, 245, 0.25);
      color: #fff;
      box-shadow: 0 2px 8px rgba(81, 52, 245, 0.2);
    }

    &:hover:not(.active) {
      color: rgba(255, 255, 255, 0.8);
    }

    &:focus {
      outline: none;
    }
  }
}

.login-form {
  padding: 20px 24px 8px;

  &--register {
    padding-top: 16px;
  }

  &--centered {
    text-align: center;
    padding-top: 8px;
  }

  label {
    display: block;
    font-size: 0.8em;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0.02em;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 0;
    margin-bottom: 8px;
  }

  .field-group {
    margin-bottom: 18px;

    &:first-child label {
      margin-top: 0;
    }
  }

  .field-input {
    position: relative;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;

    &:focus-within {
      border-color: rgba(81, 52, 245, 0.6);
      background: rgba(81, 52, 245, 0.08);
      box-shadow: 0 0 0 3px rgba(81, 52, 245, 0.15);
    }

    &.has-error {
      border-color: rgba(245, 95, 95, 0.6);
      background: rgba(245, 95, 95, 0.06);
    }

    &--select select {
      padding-left: 40px;
    }
  }

  .field-icon {
    position: absolute;
    left: 14px;
    color: rgba(255, 255, 255, 0.35);
    font-size: 0.85em;
    pointer-events: none;
    z-index: 1;
  }

  .field-toggle {
    position: absolute;
    right: 4px;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;

    &:hover {
      color: rgba(255, 255, 255, 0.8);
    }

    &:focus {
      outline: none;
    }
  }

  input,
  select,
  textarea {
    width: 100%;
    background: transparent;
    border: none;
    border-radius: 12px;
    padding: 13px 14px 13px 40px;
    margin-top: 0;
    color: #fff;
    font-size: 0.95em;

    &::placeholder {
      color: rgba(255, 255, 255, 0.3);
      font-weight: 400;
    }

    &:focus {
      outline: none;
      border: none;
    }

    &.error {
      background: transparent;
      border: none;
    }
  }

  input[type="password"],
  input[type="text"] {
    padding-right: 44px;
  }

  select {
    cursor: pointer;
    appearance: none;
    background: transparent url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23ffffff55' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right 14px center / 8px 10px;
    padding-right: 32px;
    color: #fff;

    option {
      background: #1a1a22;
      color: #fff;
    }
  }

  .hint {
    font-size: 0.78em;
    color: $error-color;
    margin-top: 6px;
  }

  .hint-center {
    text-align: center;
  }
}

.login-actions-row {
  display: flex;
  justify-content: flex-end;
  margin: -6px 0 20px;
}

.link-btn {
  background: none;
  border: none;
  padding: 4px 0;
  color: rgba(141, 110, 244, 0.9);
  font-size: 0.82em;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #a78bfa;
    text-decoration: underline;
  }

  &:focus {
    outline: none;
  }
}

.btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 48px;
  margin-top: 4px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, $primary-color 0%, $secondary-color 100%);
  color: #fff;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(81, 52, 245, 0.35);
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 24px rgba(81, 52, 245, 0.45);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }

  i {
    font-size: 0.9em;
  }
}

.alert {
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 0.82em;
  line-height: 1.4;
  text-align: center;

  &-error {
    background: rgba(245, 95, 95, 0.12);
    border: 1px solid rgba(245, 95, 95, 0.25);
    color: #ff8a8a;
  }
}

.change-pass-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 8px 24px 0;
  padding: 16px;
  border-radius: 12px;
  background: rgba(81, 52, 245, 0.1);
  border: 1px solid rgba(81, 52, 245, 0.2);
  text-align: center;

  i {
    font-size: 1.6em;
    color: $secondary-color;
  }

  p {
    margin: 0;
    font-size: 0.88em;
    color: rgba(255, 255, 255, 0.65);
    line-height: 1.5;
  }

  strong {
    color: #fff;
    font-weight: 600;
    word-break: break-all;
  }
}

.confirm-email-icon {
  font-size: 3em;
  color: $secondary-color;
  margin-bottom: 12px;
}

.confirm-email-text {
  margin: 0 0 24px;
  font-size: 0.95em;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.5;
}

.hint-center {
  text-align: center;
  margin-top: 10px !important;
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .login-modal.modal .box.login-card {
    position: static;
    top: auto !important;
    bottom: auto !important;
    left: auto !important;
    right: auto !important;
    min-width: 380px;
    max-width: 420px;
    width: 100%;
    margin: 16px;
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.08);
  }
}
</style>
